const myUrl = {
    login:'api/wap/goods/login',
    goodsLst:'api/wap/goods/lst',
    goodsDetail:'api/wap/goods/detail',
    exchange:'api/wap/goods/exchange',
    getChina:'api/wap/goods/getChina',
    getUserOrder:'api/wap/goods/getUserOrder',
    user:'api/wap/user/getUserInfo',
    uploadTicket:'/api/wap/user/uploadTicket',//上传航班票据
    submitFlyOrder:'/api/wap/user/submitFlyOrder',//提交航班信息
    qr:'api/wap/user/clientService',
}

export default myUrl
